import moment from 'moment';
import { useContext, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';

import Text from 'components/common/Text';
import { BasketContext, UserContext } from 'components/signUpFunnel/Contexts';
import { BrandContext } from 'context/BrandContext';
import useFeatureFlag from 'hooks/useFeatureFlag';
import { ALLOW_THANK_YOU_PAGE_DEVELOPMENT_WITHOUT_REDIRECTS } from 'lib/constants/featureFlags';
import styles from 'styles/components/signUpFunnel/thankYou/NextSteps';

import CutOffDateAndTime from './CutOffDateAndTime';
import { default as SmartphoneNextSteps } from './smartphone/NextSteps';
import ThankYouButton from './ThankYouButton';

const NextSteps = ({ isSmartphoneScreenSize = false, onClick }) => {
  const { basket, setBasket } = useContext(BasketContext);
  const { user } = useContext(UserContext);
  const { postSignupUrl } = useContext(BrandContext);
  const allowThankYouPageDevelopmentWithoutRedirects = useFeatureFlag(
    ALLOW_THANK_YOU_PAGE_DEVELOPMENT_WITHOUT_REDIRECTS
  );

  useEffect(() => {
    if (!allowThankYouPageDevelopmentWithoutRedirects) {
      return;
    }

    if (basket) {
      const existingBasket = localStorage.getItem('firstOrderBasket');
      if (!existingBasket) {
        localStorage.setItem('firstOrderBasket', JSON.stringify(basket));
      }
    } else {
      const storedBasket = localStorage.getItem('firstOrderBasket');
      if (storedBasket) {
        const parsedBasket = JSON.parse(storedBasket);

        setBasket(parsedBasket);
        localStorage.removeItem('firstOrderBasket');
      }
    }
  }, [basket, setBasket, allowThankYouPageDevelopmentWithoutRedirects]);

  const firstDeliveryDateFormatted = moment(basket?.deliveryDate).format('dddd, MMMM Do');

  const NextStepsContent = () => {
    return (
      <>
        <div className="flex flex-col items-center text-center">
          <Text brandStylesOverrides="h5 text-secondary">Your first box will be delivered on</Text>
          <Text brandStylesOverrides="font-medium text-primary h3" className="mb-4">
            {basket ? firstDeliveryDateFormatted : <Skeleton className={styles.skeleton150} />}
          </Text>
          <div className="flex items-center">
            <CutOffDateAndTime />
          </div>
          <div className="max-w-[650px]">
            <Text brandStylesOverrides="textSm text-charcoal-90">
              Heads up! You'll receive our pre-selected meals if you don't make changes before that
              date.
            </Text>
            <div className="mb-11 mt-4">
              <ThankYouButton
                onClick={onClick}
                postSignupUrl={postSignupUrl}
                user={user}
                variant="primary"
                buttonStyles="w-full"
              />
            </div>
          </div>
        </div>
      </>
    );
  };

  return isSmartphoneScreenSize ? (
    <SmartphoneNextSteps
      basket={basket}
      firstDeliveryDateFormatted={firstDeliveryDateFormatted}
      onClick={onClick}
      postSignupUrl={postSignupUrl}
      user={user}
    />
  ) : (
    <NextStepsContent />
  );
};

NextSteps.propTypes = {
  onClick: PropTypes.func.isRequired,
  isSmartphoneScreenSize: PropTypes.bool,
};

export default NextSteps;
